const MetaData = ({ title, description, url, keywords, job }) => {
  // --- Build JobPosting JSON-LD if job data is passed ---
  const jobPostingSchema = job
    ? {
      "@context": "https://schema.org/",
      "@type": "JobPosting",
      "title": job.title,
      "description": job.description.replace(/<[^>]*>?/gm, ""),
      "datePosted": new Date(job.createdAt).toISOString(),
      "validThrough": new Date(job.deadline).toISOString(),
      "employmentType":
        job.employmentType === "ft"
          ? "FULL_TIME"
          : job.employmentType === "pt"
            ? "PART_TIME"
            : "CONTRACTOR",
      "hiringOrganization": {
        "@type": "Organization",
        "name": job.client || job.createdBy?.companyName || "SAN Engineering Solutions",
        "sameAs": job.clientUrl || [],
        "logo": job.clientLogo || job.createdBy?.companyLogo || 
          "https://www.careerconnectai.com/CareerConnect%20Ai%20Logo.png",
      },
      "jobLocation": {
        "@type": "Place",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": job.location?.city || "India",
          "addressCountry": "IN",
        },
      },
      "baseSalary": {
        "@type": "MonetaryAmount",
        "currency": "INR",
        "value": {
          "@type": "QuantitativeValue",
          "minValue": (job.salary?.min || 0) * 100000,
          "maxValue": (job.salary?.max || 0) * 100000,
          "unitText": "YEAR",
        },
      },
      "identifier": {
        "@type": "PropertyValue",
        "name": "CareerConnect AI",
        "value": job.id,
      },
      "url": url,
      "directApply": true
    }
    : null;

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content={job ? "article" : "website"} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta
        property="og:image"
        content="https://www.careerconnectai.com/CareerConnect%20Ai%20Logo.png"
      />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta
        name="twitter:image"
        content="https://www.careerconnectai.com/CareerConnect%20Ai%20Logo.png"
      />

      {/* Organization Schema */}
      <script type="application/ld+json">{JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "SAN Engineering Solutions",
        "url": "https://careerconnectai.com",
        "logo": "https://www.careerconnectai.com/CareerConnect%20Ai%20Logo.png",
        "sameAs": ["https://www.linkedin.com/company/san-engineering-solutions"]
      })}</script>

      {/* Job Posting Schema (only when viewing a job) */}
      {jobPostingSchema && (
        <script type="application/ld+json">
          {JSON.stringify(jobPostingSchema)}
        </script>
      )}
    </>
  );
};

export default MetaData;
